// Ajustes > Nuvem e cópias de segurança (0.67, texto 05 D3): o Google Drive e OneDrive de antes, mais o
// "Exportar arquivo / Importar arquivo" que ficava na antiga "Configuração geral" (a cópia não aparece mais em dois lugares).
import { Alert, Platform } from 'react-native';
import { semBloqueio } from '../../auth/AuthContext';
import { exportBackup, importBackup } from '../../store/backup';
import { t } from '../../lib/i18n';
import Nuvem from './Nuvem';
import { BotaoAcao, Bloco, Dica } from '../../components/ajustes/Linhas';

const falhou = (err: any) => Alert.alert(t('Não foi possível'), String(err?.message ?? err));
export const exportarArquivo = () => semBloqueio(exportBackup).catch(falhou);

export default function NuvemCopias({ cor }: { cor: string }) {
  return (<>
    <Nuvem cor={cor} />
    {Platform.OS !== 'web' && (
      <Bloco titulo={t('Cópia de segurança em arquivo')}>
        <Dica>{t('Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.')}</Dica>
        <BotaoAcao cor={cor} label={t('Exportar arquivo')} onPress={exportarArquivo} />
        <BotaoAcao cor={cor} label={t('Importar arquivo')} onPress={() => Alert.alert(t('Importar backup?'), t('Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.'), [
          { text: t('Cancelar'), style: 'cancel' },
          { text: t('Escolher arquivo'), style: 'destructive', onPress: () => semBloqueio(importBackup).then(ok => ok && Alert.alert(t('Backup importado.'))).catch(falhou) }])} />
      </Bloco>
    )}
  </>);
}
